/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState } from "react";
import {
  Upload,
  message,
  Alert,
  Tooltip,
  Image,
  Button,
  Divider,
  Spin,
  Popconfirm,
  Modal,
  notification,
} from "antd";
import {
  InboxOutlined,
  QuestionCircleOutlined,
  CloseOutlined,
  SaveOutlined,
  ArrowDownOutlined,
  FormOutlined,
  DeleteTwoTone,
  CheckCircleTwoTone,
  EyeOutlined,
} from "@ant-design/icons";
import CaSideNav from "../../../components/AdminComponents/CaSideNav";
import SecondaryNav2 from "../../../components/AdminComponents/SecondaryNav2";
import {
  CaAdminMenu,
  SecondaryNavSettingsCA,
} from "../../../components/AdminComponents/MenuItems";
import { useSelector } from "react-redux";
import Axios from "../../../api/Axios";
import axios from "axios";
import moment from "moment";
import { useDispatch } from "react-redux";
import { setClientData } from "../../../store/slices/OrgDetail";
import { getUpdateStatus } from "../../../components/AdminComponents/ViewUpdateIndex";
import { capitalizeWords } from "../../../components/icons/ApplicationColor";

const { Dragger } = Upload;
const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
const LogoUploader = () => {
  const [logo, setLogo] = useState(false);
  const [Mopen, setMopen] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [visibleImg2, setVisibleImg2] = useState(false);
  const [originalImageUrl, setOrginalImageUrl] = useState();
  const [resizedImageUrl, setResizedImageurl] = useState();

  const dispatch = useDispatch();
  const namingData = useSelector((state) => state.orgdeatil);
  //console.log(namingData);
  const [api, contextHolder2] = notification.useNotification();
  const scaleStep = 1.0;
  const openNotificationWithIcon = (originalImageUrl, resizedImageUrl) => {
    const description = (
      <div>
        <p>
          The uploaded image size was not acceptable, so the image size has been
          adjusted. If you are unhappy with the resized image, please upload
          again.
        </p>
        <div>
          <Button type="primary" onClick={() => setVisible(true)}>
            show image preview
          </Button>
          <Image
            width={200}
            style={{
              display: "none",
            }}
            src={originalImageUrl}
            preview={{
              visible,
              scaleStep,
              src: originalImageUrl,
              onVisibleChange: (value) => {
                setVisible(value);
              },
            }}
          />
        </div>
        <div>
          <p>Resized Image:</p>
          <Image.PreviewGroup>
            <Image src={URL.createObjectURL(resizedImageUrl)} />
          </Image.PreviewGroup>
        </div>
      </div>
    );

    api.warning({
      message: "Image Size Adjusted",
      duration: 0,
      description: description,
    });
  };

  const userInfo = useSelector((state) => state.user);

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");

  const handlePreview = async (file) => {
    //console.log("preview");
    if (!file.url && !file.preview) {
      try {
        const preview = await getBase64(file.originFileObj || file);
        file.preview = preview;
        setPreviewImage(preview);
        setPreviewTitle(
          file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
        );
      } catch (error) {
        console.error("Error generating preview:", error);
      }
    } else {
      setPreviewImage(file.url || file.preview);
      setPreviewTitle(
        file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
      );
    }
  };

  // ... rest of your component code

  const UpdateSuccessfull = (props) => {
    messageApi.open({
      type: "success",
      content:
        props === "add" ? "Logo has been uploaded" : "Logo has been removed",
      duration: 5,
    });
  };

  const UpdateFailed = (props) => {
    messageApi.open({
      type: "error",
      content: props === "add" ? "Logo Upload Failed" : "Logo remove Failed",
      duration: 5,
    });
  };
  // eslint-disable-next-line no-unused-vars
  const dimensionsError = (originalImageUrl, resizedImageUrl) => {
    openNotificationWithIcon(
      originalImageUrl,
      resizedImageUrl,
      visible,
      setVisible
    );
    messageApi.open({
      type: "error",
      content: "Height and width of the logo is INVALID",
      duration: 7,
    });
  };
  const LoadUser = async () => {
    try {
      const res = await Axios.get(
        `/organization/${userInfo.data.organization.id}/`
      );

      //console.log(res.data);

      const {
        client_id,
        name,
        dep_label,
        div_label,
        entity_label,
        logo,
        logo_url,
      } = res.data;
      dispatch(
        setClientData({
          client_id,
          name,
          dep_label,
          div_label,
          entity_label,
          logo,
          logo_url,
        })
      );
    } catch (err) {
      //console.log(err);
    }
  };
  const onFinish = async (props) => {
    const values1 = {
      logo: fileName,
      updated_at: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
    };
    const values2 = {
      logo: null,
      updated_at: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
    };
    const values = props === "add" ? values1 : values2;

    try {
      await Axios.put(
        `/organization/${userInfo.data.organization.id}/`,
        values,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      //console.log(res);
      LoadUser();
      UpdateSuccessfull(props);
      handleCancelClick();
    } catch (err) {
      //console.log(err);
      UpdateFailed(props);
    }
  };
  const [fileList, setFileList] = useState([]);
  const handleLogoUpload2 = async (file) => {
    setLoading(true);
    console.log(file, "file");

    const payload = {
      filename: file.name,
      type: "organization",
    };

    try {
      const response = await Axios.post("/uploadurl/", payload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });

      //console.log(response);
      const file_name = response.data.filename;
      const url = response.data.url;
      // console.log(file, "payload2");

      try {
        const res = await axios.put(url, file);

        //console.log(res);
        if (res.status === 200) {
          // File uploaded successfully
          setFileName(file_name);
          handlePreview(file);
          setFileList([file]);
          setLogo(true);
          setLoading(false);
        } else {
          // Handle upload error
          console.error("Error uploading file.");
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.error("Error uploading file:", error);
        // You may want to set an error state or show an error message here
      }
    } catch (error) {
      setLoading(false);
      console.error("Error getting upload URL:", error);
      // You may want to set an error state or show an error message here
    }
  };
  const handleCancelClick = () => {
    // Clear the uploaded logo
    setLogo(false);
    setFileName("");
    setFileList([]);
    setOrginalImageUrl();
    setResizedImageurl();
    setVisible(false);
    setVisible2(false);
    setVisibleImg2(false);
  };
  const handleCancel = () => setMopen(false);
  const updateAuth = getUpdateStatus(userInfo, 1, 0);
  return (
    <CaSideNav props={CaAdminMenu}>
      {contextHolder}
      {contextHolder2}
      <SecondaryNav2 menuItems={SecondaryNavSettingsCA} />
      <div className="existing-logo">
        <div className="sub-box-conatiner">
          <div className="form-heading">
            {capitalizeWords(" LOGO UPLOAD")}{" "}
            <Tooltip title="Click to view note">
              <QuestionCircleOutlined
                className="upload-icon"
                style={{ cursor: "pointer", marginLeft: "0.5rem" }}
              />
            </Tooltip>
          </div>
          <div
            className="subscription-box"
            style={{
              fontFamily: "Poppins",
              fontSize: "1.5rem",
              paddingInline: "1rem",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "10px",
              }}
            >
              <Alert
                message="Note"
                description={
                  <>
                    <ul>
                      <li>
                        Uploaded logo will be displayed on the top left corner
                        throughout the application.
                      </li>
                    </ul>
                    <ul>
                      <li
                        style={{
                          paddingTop: "5px",
                        }}
                      >
                        The uploaded logo must follow below given dimensions :
                        <ul
                          style={{
                            marginLeft: "10px",
                            fontSize: "13px",
                            paddingTop: "3.5px",
                          }}
                        >
                          <li>
                            Width between <strong>360</strong> and{" "}
                            <strong>850</strong> pixels
                          </li>
                          <li>
                            Height between <strong>80</strong> and{" "}
                            <strong>250</strong> pixels
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </>
                }
                type="info"
                showIcon
                style={{
                  width: "48%", // Adjust width as needed
                  fontFamily: "Poppins",
                  fontSize: "1.4rem",
                }}
              />

              {visibleImg2 && (
                <Alert
                  message="Image Size Adjusted"
                  type="warning"
                  description={
                    <>
                      <ul>
                        <li
                          style={{
                            paddingTop: "5px",
                          }}
                        >
                          The uploaded image size was not acceptable, so the
                          image size has been adjusted. If you are unhappy with
                          the resized image, please upload again.
                        </li>
                        <ul>
                          <li>
                            <div
                              style={{
                                display: "flex",
                                gap: "15px",
                                marginTop: "15px",
                              }}
                            >
                              <Button
                                type="dashed"
                                icon={<EyeOutlined />}
                                onClick={() => setVisible(true)}
                              >
                                Show Original Image
                              </Button>
                              <Image
                                style={{
                                  display: "none",
                                }}
                                src={originalImageUrl}
                                preview={{
                                  visible,
                                  scaleStep,
                                  src: originalImageUrl,
                                  onVisibleChange: (value) => {
                                    setVisible(value);
                                  },
                                }}
                              />
                              <Button
                                type="dashed"
                                icon={<EyeOutlined />}
                                onClick={() => setVisible2(true)}
                              >
                                Show Resized Image
                              </Button>
                              <Image
                                style={{
                                  display: "none",
                                }}
                                src={URL.createObjectURL(resizedImageUrl)}
                                preview={{
                                  visible: visible2,
                                  scaleStep,
                                  src: URL.createObjectURL(resizedImageUrl),
                                  onVisibleChange: (value) => {
                                    setVisible2(value);
                                  },
                                }}
                              />
                            </div>
                          </li>
                        </ul>
                      </ul>
                    </>
                  }
                  showIcon
                  style={{
                    width: "48%", // Adjust width as needed
                    fontFamily: "Poppins",
                    fontSize: "1.4rem",
                  }}
                />
              )}
            </div>

            <Divider style={{ borderColor: "#B2BEB5" }} />
            {namingData?.logo_url ? (
              <>
                <div
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "1.5rem",
                    paddingInline: "3rem",
                    paddingTop: "0.1rem",
                    paddingBottom: "2rem",
                  }}
                >
                  EXISTING LOGO :
                  <Image
                    src={namingData?.logo_url}
                    width={145}
                    height={40}
                    style={{ marginLeft: "1rem" }}
                  />
                  {updateAuth && (
                    <Popconfirm
                      title={"Remove Logo"}
                      description=" "
                      onConfirm={() => onFinish("remove")}
                      okText="Yes"
                      cancelText="No"
                    >
                      <DeleteTwoTone
                        style={{
                          cursor: "pointer",
                          fontSize: "1.8rem",
                          marginLeft: "2rem",
                        }}
                        // onClick={() => {
                        //   handleDelete(record);
                        // }}
                        title="delete"
                        twoToneColor="#eb2f96"
                      />
                    </Popconfirm>
                  )}
                  {!updateAuth &&
                    "The account doesn't have Logo upload access "}
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "1.5rem",
                    paddingInline: "3rem",
                    paddingTop: "0.1rem",
                    paddingBottom: "1.5rem",
                  }}
                >
                  {updateAuth
                    ? "No Logo is present, Please upload the logo below "
                    : "This account doesn't have Logo upload access "}
                  {updateAuth && (
                    <ArrowDownOutlined
                      style={{
                        fontSize: "1.8rem",
                      }}
                    />
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {updateAuth && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "3rem",
          }}
        >
          <Dragger
            style={{
              width: "47.5rem",
              padding: "1.2rem",
              background: "#F7F8F9",
            }}
            name="logo"
            accept=".png,.jpg,.jpeg"
            beforeUpload={(file) => {
              console.log(file, "file-1");
              const reader = new FileReader();
              reader.readAsDataURL(file);
              reader.addEventListener("load", (event) => {
                const _loadedImageUrl = event.target.result;
                const image = document.createElement("img");
                image.src = _loadedImageUrl;
                image.addEventListener("load", () => {
                  const { width, height } = image;

                  // Check if dimensions meet the specified limitations
                  if (
                    width >= 300 &&
                    width <= 850 &&
                    height >= 80 &&
                    height <= 250
                  ) {
                    // If conditions are met, proceed with the upload
                    //console.log("Image dimensions:", width, "x", height);
                    setVisibleImg2(false);
                    handleLogoUpload2(file);
                  } else {
                    const canvas = document.createElement("canvas");
                    canvas.width = 350;
                    canvas.height = 100;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(image, 0, 0, 350, 100);

                    // Convert canvas to Blob
                    canvas.toBlob((blob) => {
                      const resizedFile = new File([blob], file.name, {
                        type: file.type,
                      });
                      setVisibleImg2(true);
                      setOrginalImageUrl(_loadedImageUrl);
                      setResizedImageurl(resizedFile);
                      // dimensionsError(_loadedImageUrl, resizedFile);
                      handleLogoUpload2(resizedFile);
                    }, file.type);
                  }
                });
              });

              // Prevent default upload behavior of Dragger component
              return false;
            }}
            fileList={fileList}
            onPreview={() => {
              setMopen(true);
            }}
            onRemove={() => handleCancelClick()}
          >
            <Spin spinning={loading}>
              {!logo ? (
                <>
                  {" "}
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Click or drag file to this area to upload logo
                  </p>
                  <p className="ant-upload-hint">
                    Support for PNG, JPG, and JPEG files.
                  </p>
                </>
              ) : (
                <>
                  <p className="ant-upload-text">
                    <CheckCircleTwoTone style={{ fontSize: "3rem" }} />
                  </p>
                  <img
                    alt=""
                    src={previewImage}
                    width="138.75"
                    height="35"
                    className="logo-styles"
                    style={{ padding: "5px" }}
                  />
                  <p className="ant-upload-hint">
                    The Logo will appear has given above
                  </p>
                </>
              )}
            </Spin>
          </Dragger>

          <Modal
            open={Mopen}
            title={previewTitle}
            footer={null}
            onCancel={handleCancel}
          >
            <img alt="example" style={{ width: "100%" }} src={previewImage} />
          </Modal>
          {logo && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                marginLeft: "2rem",
                height: "100px",
              }}
            >
              <Button
                className="save-update-btn"
                type="primary"
                htmlType="submit"
                onClick={() => onFinish("add")}
              >
                {namingData?.logo_url ? "Update" : "Save"}{" "}
                {namingData?.logo_url ? <SaveOutlined /> : <FormOutlined />}
              </Button>
              <Button
                type="text"
                htmlType="button"
                style={{
                  background: "#D3D3D3",
                }}
                onClick={handleCancelClick}
              >
                Cancel <CloseOutlined />
              </Button>
            </div>
          )}
        </div>
      )}
    </CaSideNav>
  );
};

export default LogoUploader;
